// @flow
import React from "react";
import Icon, { type IconProps } from "../";

export default function Rating({
  width = "18px",
  fill = "currentColor",
  ...props
}: IconProps) {
  return (
    <Icon viewBox="0 0 18 14" width={width} fill={fill} {...props}>
      <path
        d="M-1268-215h-11v-9h6v-5h6v8h6v6Z"
        transform="translate(1279 229)"
      />
    </Icon>
  );
}

export function Podium({
  width = "18px",
  fill = "currentColor",
  ...props
}: IconProps) {
  return (
    <Icon viewBox="0 0 56 42" width={width} fill={fill} {...props}>
      <g transform="translate(0 -64)">
        <g transform="translate(0 64)">
          <path
            d="M395.543,213.977a1.169,1.169,0,0,0-1.043-.644H384v2.333h12.388Z"
            transform="translate(-342 -197)"
          />
          <path
            d="M183.338,64.644A1.169,1.169,0,0,0,182.3,64H165.962a1.169,1.169,0,0,0-1.043.644l-.845,1.689h20.109Z"
            transform="translate(-146.128 -64)"
          />
          <path
            d="M55.947,123.9a1.3,1.3,0,0,0-.058-.217A1.165,1.165,0,0,0,54.834,123H39.667V107.834a1.139,1.139,0,0,0-.054-.268,1.3,1.3,0,0,0-.058-.217,1.165,1.165,0,0,0-1.055-.681h-21a1.168,1.168,0,0,0-1.055.681,1.1,1.1,0,0,0-.058.217,1.142,1.142,0,0,0-.054.268v12.833H1.167a1.168,1.168,0,0,0-1.055.681,1.1,1.1,0,0,0-.058.217,1.143,1.143,0,0,0-.054.268v21A1.169,1.169,0,0,0,1.167,144H54.834A1.169,1.169,0,0,0,56,142.834V124.167A1.147,1.147,0,0,0,55.947,123.9Zm-44.28,10.766h0v0a1.167,1.167,0,1,1,0,2.333H7a1.168,1.168,0,0,1-.826-1.993l3.017-3.017a4.449,4.449,0,0,0,1.309-3.159,1.167,1.167,0,0,0-2.333,0,1.167,1.167,0,1,1-2.333,0,3.5,3.5,0,0,1,7,0,6.761,6.761,0,0,1-1.993,4.809l-1.024,1.024ZM30.336,126.5h0a1.167,1.167,0,1,1-2.333,0v-8.85l-.341.341a1.167,1.167,0,1,1-1.65-1.65l2.333-2.333a1.168,1.168,0,0,1,1.993.826V126.5Zm19.831,9.333a3.5,3.5,0,0,1-7,0,1.167,1.167,0,1,1,2.333,0,1.167,1.167,0,1,0,1.167-1.167,1.167,1.167,0,1,1,0-2.333,1.167,1.167,0,1,0-1.167-1.167,1.167,1.167,0,1,1-2.333,0,3.5,3.5,0,1,1,6.106,2.333A3.487,3.487,0,0,1,50.167,135.834Z"
            transform="translate(0 -102)"
          />
          <path
            d="M27.129,192h-10.5a1.169,1.169,0,0,0-1.043.644l-.845,1.689H27.129Z"
            transform="translate(-13.129 -178)"
          />
        </g>
      </g>
    </Icon>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Tournaments/Rating.js